import { ReactNode } from "react";
import Styles from './NSColumn.module.css';
import { IBaseComponentProps } from "../props/IBaseComponentProps";

export interface NSColumnProps extends IBaseComponentProps
{
    children: ReactNode;
    onEnterPressed?: () => void;
}
export function NSColumn(props: NSColumnProps)
{
    return (
        <div id={props.id}
            className={`${Styles.ns_column} ${props.classList?.join(" ") ?? ""}`}
            style={props.style}
            onKeyUp={e =>
            {
                if (e.key === "Enter")
                    props.onEnterPressed?.();
            }}
        >
            {props.children}
        </div>
    );
}